import type {
  LabwareContent,
  LabwareType,
  LoadOrderCarouselLayout,
  LoadOrderGridLayout,
  NodePosition,
  Option,
} from './types';

export const LABWARE_DEPENDENCY_EDGE = 'LABWARE_DEPENDENCY_EDGE';
export const TIME_CONSTRAINT_EDGE = 'TIME_CONSTRAINT_EDGE';
export const DATA_DEPENDENCY_EDGE = 'DATA_DEPENDENCY_EDGE';
export const TASK_DEPENDENCY_EDGE = 'TASK_DEPENDENCY_EDGE';

export const TIME_CONSTRAINT_HANDLE_START = 'start';
export const TIME_CONSTRAINT_HANDLE_END = 'end';

export const DATA_HANDLE_IDENTIFIER = 'DATA_HANDLE_IDENTIFIER';
export const TASK_DEPENDENCY_HANDLE_IDENTIFIER =
  'TASK_DEPENDENCY_HANDLE_IDENTIFIER';

export const TARGET_HANDLE_IDENTIFIER = 'target';
export const SOURCE_HANDLE_IDENTIFIER = 'source';

export const DATA_INPUT = 'DATA_INPUT';

// Auto-save configuration
export const AUTO_SAVE_INTERVAL_MS = 2 * 60 * 1000; // 2 minutes
export const getAutoSaveStorageKey = (workflowId: string): string =>
  `workflow-builder-autosave-enabled-${workflowId}`;

// Time constraint errors
export const NO_COMMON_LABWARE = 'NO_COMMON_LABWARE';
export const MIN_GREATER_THAN_MAX_DURATION = 'MIN_GREATER_THAN_MAX_DURATION';

export const LABWARE_TYPES: readonly LabwareType[] = [
  'microplate',
  'reservoir',
  'tuberack',
  'tiprack',
] as const;

export const LABWARE_CONTENT_LIST: readonly LabwareContent[] = [
  'empty',
  'sample',
  'reagent',
  'other',
];
export const DEFAULT_LABWARE_CONTENT: LabwareContent = 'empty';

export const loadOrderGridLayoutValues: readonly LoadOrderGridLayout[] = [
  'firstToLast',
  'lastToFirst',
  'custom',
  'any',
];
export const loadOrderCarouselLayoutValues: readonly LoadOrderCarouselLayout[] =
  ['clockwise', 'counterclockwise', 'custom', 'any'];

export const BACKGROUND_DRIVER_NAMES: string[] = [
  'automata_safety_adapter',
  'automata_slider',
  'automata_evaluator',
  'automata_sftp', // TODO(LT, 04/11/2024): This is TBC and may be changed later
  'automata_turntable',
];

export const DATA_EXPORT_CONNECTORS: Record<string, Option> = {
  sftp: { id: 'sftp', name: 'File Transfer (SFTP)' },
  // (LT, 04/11/2024): This is TBC and may be changed later
  // s3: { id: 's3', name: 'File Transfer (S3)' },
};

export const ONE_OF_FIELDS = {
  protocol: [
    'protocol_path',
    'onboard_protocol',
    'protocol_file_path',
    'onboard_protocol_name',
  ],
};

export const ZEROED_NODE_POSITION: NodePosition = { x: 0, y: 0 };
